import { defineAction } from 'redux-define';
import * as SA from './actions/sub.actions';

const application = defineAction('ckp');
const global = defineAction('global', [], application);
const authentication = defineAction('authentication', [], application);
const events = defineAction('events', [], application);
const artists = defineAction('artists', [], application);
const admin = defineAction('admin', [], application);

// APPLICATION
export const API = defineAction('API', SA.API_CODES, global);
export const FLASH = defineAction('FLASH', [SA.OPEN, SA.CLOSE]);
export const LOGIN = defineAction(
    'LOGIN',
    [SA.INPUT, SA.SUBMIT, SA.REFRESH, SA.SUCCESS, SA.FAILED, SA.CANCEL, SA.REFRESH],
    authentication
);
export const USERS = defineAction('USERS', [SA.FETCH_OK, SA.UPDATE], authentication);
export const FORGOT_PASSWORD = defineAction(
    'FORGOT_PASSWORD',
    [SA.INPUT, SA.SUBMIT, SA.SUCCESS, SA.FAILED],
    authentication
);
export const CHANGE_PASSWORD = defineAction(
    'CHANGE_PASSWORD',
    [SA.INPUT, SA.SUBMIT, SA.SUCCESS, SA.FAILED],
    authentication
);
export const EVENTS_SELECT = defineAction('SELECT', [SA.CHANGE, SA.FETCH_OK, SA.FETCH_START, SA.DONE], events);
export const NOTIFICATIONS_TIMETABLE = defineAction('NOTIFICATIONS_TIMETABLE', [SA.FETCH_OK, SA.FETCH_START], events);
export const EVENTS_TIMETABLE = defineAction('TIMETABLE', [SA.FETCH_OK, SA.FETCH_START, SA.SWITCH, SA.UPDATE], events);
export const EVENTS_ENTRY = defineAction('ENTRY', [SA.SHOW, SA.HIDE], events);
export const ARTISTS_CONTACTS = defineAction('CONTACTS', [SA.FETCH_START, SA.FETCH_OK], artists);
export const EVENTS_SEARCH = defineAction(
    'SEARCH',
    [SA.INPUT, SA.OPEN, SA.CLOSE, SA.CLEAR, SA.FETCH_OK, SA.FETCH_START],
    events
);
export const EVENTS_FILTER = defineAction(
    'FILTER',
    [SA.OPEN, SA.CLOSE, SA.SELECT, SA.TOGGLE, SA.TOGGLE_ALL, SA.TOGGLE_ONE, SA.SET],
    events
);
export const APP_MENU = defineAction('APP_MENU', [SA.CLOSE, SA.OPEN, SA.SUB_CLOSE, SA.SUB_OPEN], global);

export const CONTRACTS_INBOX = defineAction('CONTRACTS_INBOX', [SA.FETCH_START, SA.FETCH_OK, SA.UPDATE]);
export const CONTRACTS_REVIEW = defineAction('CONTRACTS_REVIEW', [
    SA.FETCH_START,
    SA.FETCH_OK,
    SA.OPEN,
    SA.CLOSE,
    SA.INPUT,
    SA.CHANGE,
    SA.SUBMIT,
    SA.SUBMIT_DONE,
    SA.TOGGLE,
    SA.SWITCH
]);

// ADMIN
export const ADMIN_CONTEXT = defineAction('CONTEXT', [SA.OPTIONS, SA.SET, SA.ADD, SA.UPDATE], admin);
export const ADMIN_TABLES = defineAction(
    'TABLES',
    [
        SA.INITIALIZE,
        SA.SEARCH,
        SA.SORT,
        SA.REFRESH,
        SA.FETCH_START,
        SA.FETCH_OK,
        SA.SELECT,
        SA.DISABLE,
        SA.UPDATE_FILTER,
        SA.DELETE,
        SA.REFRESH,
        SA.CHANGE,
        SA.UPDATE
    ],
    admin
);
export const ADMIN_IMPORTS = defineAction(
    'IMPORTS',
    [SA.CANCEL, SA.SHOW, SA.SELECT, SA.TOGGLE, SA.INPUT, SA.DONE],
    admin
);
export const ADMIN_FLASH = defineAction('FLASH', [SA.OPEN, SA.CLOSE], admin);
export const ADMIN_FORMS = defineAction(
    'FORMS',
    [
        SA.INPUT,
        SA.SUBMIT,
        SA.SUCCESS,
        SA.FAILED,
        SA.FETCH_OK,
        SA.FETCH_START,
        SA.INPUT_KEY_VALUE,
        SA.DELETE_KEY_VALUE,
        SA.RESET,
        SA.SET,
        SA.UPDATE,
        SA.REFRESH
    ],
    admin
);
export const ADMIN_BREADCRUMB = defineAction('BREADCRUMB', [SA.SET, SA.REFRESH], admin);
export const ADMIN_MODAL_FORMS = defineAction(
    'MODAL_FORMS',
    [SA.OPEN, SA.SET, SA.CLOSE, SA.INPUT, SA.SUBMIT, SA.SUCCESS, SA.FAILED, SA.FETCH_START, SA.FETCH_OK, SA.INITIALIZE],
    admin
);
export const ADMIN_TABS = defineAction('TABS', [SA.SET, SA.DISABLE, SA.ENABLE], admin);

export const ADMIN_LINEUP = defineAction(
    'LINEUP',
    [SA.FETCH_START, SA.FETCH_OK, SA.ADD, SA.REFRESH, SA.UPDATE, SA.DELETE],
    'admin'
);



// WEBPACK FOOTER //
// ./src/constants/actions.js